import styled from 'styled-components';
import { getContrastColor } from '../../utils/colorUtils';

export const Title = styled.h1`
  text-align: center;
  color: ${props => getContrastColor(props.bgColor || '#ffffff')};
  margin-bottom: 30px;
  font-size: 28px;
`;

export const FormGroup = styled.div`
  margin-bottom: 20px;
`;

export const Label = styled.label`
  display: block;
  margin-bottom: 8px;
  color: ${props => getContrastColor(props.bgColor || '#ffffff')};
  font-weight: 600;
  font-size: 14px;
`;

export const Input = styled.input`
  width: 100%;
  padding: 14px;
  border: 2px solid ${props => {
    const contrastColor = getContrastColor(props.bgColor || '#ffffff');
    return contrastColor === '#ffffff' ? '#444' : '#ddd';
  }};
  border-radius: 8px;
  font-size: 15px;
  background-color: ${props => {
    const contrastColor = getContrastColor(props.bgColor || '#ffffff');
    return contrastColor === '#ffffff' ? '#1a1a1a' : '#f8f9fa';
  }};
  color: ${props => getContrastColor(props.bgColor || '#ffffff') === '#ffffff' ? '#ffffff' : '#333'};
  transition: all 0.3s;

  &::placeholder {
    color: ${props => getContrastColor(props.bgColor || '#ffffff') === '#ffffff' ? '#999' : '#999'};
  }

  &:focus {
    outline: none;
    border-color: ${props => props.accentColor || '#667eea'};
    background-color: ${props => {
      const contrastColor = getContrastColor(props.bgColor || '#ffffff');
      return contrastColor === '#ffffff' ? '#2a2a2a' : '#fff';
    }};
    box-shadow: 0 0 0 3px ${props => props.accentColor ? props.accentColor + '20' : 'rgba(102, 126, 234, 0.1)'};
  }
`;

export const Button = styled.button`
  width: 100%;
  padding: 14px;
  background: var(--accent-color, #667eea);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;

  &:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px var(--accent-color, rgba(102, 126, 234, 0.4));
  }

  &:disabled {
    opacity: 0.6;
  }
`;

export const ErrorMessage = styled.p`
  color: #e74c3c;
  font-size: 14px;
  margin-top: 10px;
`;

export const PasswordWrapper = styled.div`
  position: relative;
  input { padding-right: 44px; }
`;

export const EyeBtn = styled.button`
  position: absolute; right: 12px; top: 50%; transform: translateY(-50%);
  background: none; border: none; cursor: pointer; padding: 0;
  color: rgba(255,255,255,0.4); display: flex; align-items: center;
  &:hover { color: rgba(255,255,255,0.8); }
`;

export const LinkText = styled.p`
  text-align: center;
  margin-top: 20px;
  color: ${props => getContrastColor(props.bgColor || '#ffffff')};
  font-size: 14px;

  a {
    color: var(--accent-color, #667eea);
    font-weight: 600;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }
`;
